/* eslint-disable */
/* this file is generated by generateIcons script */

import React from 'react'
import BaseIcon from '../../BaseIcon'

export default class MacIcon extends BaseIcon {
  getChildren = () => [
    <g>
      <path fill="#D0E9FB" d="M25.7,35.5c-5.8,0.2-12-0.9-17.3-3.5l1.1-1.7c5.1,2.4,11,3.2,16.2,3c0,0.2,0.2-3.5,0.6-5.5h-7.8 c0.7-8.1,3.2-15.4,7-21.5H2v35.5h24.6C26.1,39.6,25.7,35.4,25.7,35.5L25.7,35.5z"/>
      <path fill="#00ACEC" d="M28.1,33.1c4.3-0.4,8-1.5,10.3-3l1.4,1.7c-3.2,1.8-7.2,3-11.7,3.5c0.1,2.2,0.5,4.3,1,6.4H46V6.3H28 c-3.8,5.8-6,12.3-6.8,19.2h8.1C28.6,28,28.2,30.6,28.1,33.1L28.1,33.1z M12.7,11.6h2.3v5.3h-2.3V11.6z"/>
      <path d="M31.7,11.6H34v5.3h-2.3V11.6z"/>
      <path d="M28.1,33.1c4.3-0.4,8-1.5,10.3-3l1.4,1.7c-3.2,1.8-7.2,3-11.7,3.5c0.2,4,1.2,7.9,3.1,11.6l-1.9,1c-3.6-5.6-4.2-13.1-3-20.2 h-7.8c1-11.1,5.3-20.5,11.5-27.8l1.7,1.5c-6.1,7-9.4,15.2-10.4,24h8.1C28.6,28,28.2,30.6,28.1,33.1z"/>
      <path fill="#00ACEC" d="M25.7,33.3v2.2c-5.8,0.2-12-0.9-17.3-3.5l1.1-1.7C14.7,32.7,20.5,33.5,25.7,33.3L25.7,33.3z"/>
    </g>
  ]
  getViewBox = () => '0 0 48 48'
}
